import {
  getRouteConfigForVariant,
  navigateToNextOnboardingPage,
} from '@app-studio-web/ui/helpers/abTestRouting'
import { trackOnboardingFormData } from '@app-studio-web/ui/helpers/snowplowTracking'
import { getABTestVariantFromContext } from '@app-studio-web/ui/helpers/variantContext'
import { longevityCompassABTestRouteConfig } from '@config/abTestConfig'

export default async function navigateToNextOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  const url = new URL(request.url)
  if (url.searchParams.get('mode') === 'update') {
    return null
  }

  const variant = getABTestVariantFromContext()
  const formData = await request.formData()

  trackOnboardingFormData({
    formData,
    url: request.url,
    orderedRoutes: getRouteConfigForVariant(
      variant,
      longevityCompassABTestRouteConfig,
    ),
  })

  return navigateToNextOnboardingPage({
    request,
    routeConfig: longevityCompassABTestRouteConfig,
    variant,
    redirectOnComplete: '/sign-up/company',
  })
}
